const PAGE_TREATMENT = (() => {
  let treatmentSwiper = null;
  let isMobile = window.innerWidth <= 750;
  
  const setAnimateOnScroll = () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    const distance = 60;
    const configEffects = {
      'fade-up': {
        from: { y: distance, opacity: 0 },
        onEnter: { y: 0, opacity: 1 },
        onLeave: { y: distance, opacity: 0 }
      },
      'fade-down': {
        from: { y: -distance, opacity: 0 },
        onEnter: { y: 0, opacity: 1 },
        onLeave: { y: -distance, opacity: 0 }
      },
      'fade-left': {
        from: { x: -distance, opacity: 0 },
        onEnter: { x: 0, opacity: 1 },
        onLeave: { x: -distance, opacity: 0 }
      },
      'fade-right': {
        from: { x: distance, opacity: 0 },
        onEnter: { x: 0, opacity: 1 },
        onLeave: { x: distance, opacity: 0 }
      }
    };

    Object.entries(configEffects).forEach(([value, effect]) => {
      const elements = gsap.utils.toArray(`[data-animate="${value}"]`);
      if (!elements.length) return;

      gsap.set(elements, effect.from);

      ScrollTrigger.batch(elements, {
        start: 'top bottom-=120',
        invalidateOnRefresh: true,
        onEnter: (item) => gsap.to(item, { ...effect.onEnter, duration: 1, stagger: 0.1 }),
        onEnterBack: (item) => gsap.to(item, { ...effect.onEnter, duration: 1, stagger: 0.1 }),
        onLeaveBack: (item) => gsap.to(item, { ...effect.onLeave, duration: 1, stagger: 0.1 })
      });
    });
  };

  const setTreatmentSlider = () => {
      const sliderEl = document.querySelector('.page-professional-treatment__slider');
      if (!sliderEl || typeof Swiper === 'undefined') return;
    
      if (treatmentSwiper) {
        treatmentSwiper.destroy(true, true);
        treatmentSwiper = null;
      }
    
      treatmentSwiper = new Swiper('.page-professional-treatment__slider', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: isMobile,
        loop: isMobile,
    
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
    
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
    
        mousewheel: false,
        keyboard: true,
    
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous Slide',
          nextSlideMessage: 'Next Slide'
        }
        
      });
  };

  const init = () => {
      setAnimateOnScroll();
      setTreatmentSlider();
    
      const mediaQuery = window.matchMedia('(max-width: 750px)');
    
      mediaQuery.addEventListener('change', (e) => {
        isMobile = e.matches;
        setTreatmentSlider();
      });
    };

  return { init };
})();

document.addEventListener('DOMContentLoaded', () => PAGE_TREATMENT.init());

window.addEventListener('load', () => {
  if (typeof ScrollTrigger !== 'undefined') {
    requestAnimationFrame(() => ScrollTrigger.refresh());
  }
});